import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { WidthProps } from 'styled-system';

import Box from 'components/Box';
import { breakpoints, gutterWidth, maxWidth } from 'theme';

const flexPropertyMap = {
  end: 'flex-end',
  start: 'flex-start',
};
export const StyledGridItem = styled(Box)`
  grid-column-start: 1;
  -ms-grid-column: 1;
  grid-column-end: 13;
  -ms-grid-column-span: 12;
  ${({
    columnStart = [1, 1, 1, 1],
    columnEnd = [13, 13, 13, 13],
    justifySelf = 'stretch',
    alignSelf = 'start',
    order = 'auto',
  }: {
    columnStart?: Array<number>;
    columnEnd?: Array<number>;
    justifySelf?: string;
    alignSelf?: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    order?: any;
  }) => `
    display: flex;
    width: 100%;
    padding: 0 20px;
    justify-content: ${flexPropertyMap[justifySelf] || justifySelf};
    align-items: ${flexPropertyMap[alignSelf] || alignSelf};
    flex-wrap: wrap;
    > * {
      width: 100%;
      flex: 0 0 auto;
    }
    @supports (grid-column-gap: ${gutterWidth}px) {
      display: block;
      width: auto;
      padding: 0;
      justify-self: ${justifySelf};
      align-self: ${alignSelf};
    }
    order: ${order};
    @media (min-width: ${breakpoints[0]}) {
      grid-column-start: ${columnStart[0]};
      grid-column-end: ${columnEnd[0]};
    }
    @media (min-width: ${breakpoints[1]}) {
      grid-column-start: ${columnStart[1]};
      grid-column-end: ${columnEnd[1]};
    }
    @media (min-width: ${breakpoints[2]}) {
      grid-column-start: ${columnStart[2]};
      grid-column-end: ${columnEnd[2]};
    }
    @media (min-width: ${breakpoints[3]}) {
      grid-column-start: ${columnStart[3]};
      grid-column-end: ${columnEnd[3]};
    }
  `}
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const GridItem = ({
  columnStart,
  columnEnd,
  justifySelf,
  alignSelf,
  order,
  ...props
}: WidthProps & {
  children?: ReactNode;
  columnStart?: Array<number>;
  columnEnd?: Array<number>;
  justifySelf?: string;
  alignSelf?: string;
  order?: number | string;
}) => (
  <StyledGridItem
    columnStart={columnStart}
    columnEnd={columnEnd}
    justifySelf={justifySelf}
    alignSelf={alignSelf}
    order={order}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/jsx-props-no-spreading
const Grid = styled((props) => <Box {...props} />)`
  margin: 0 auto;
  @supports (grid-column-gap: ${gutterWidth}px) {
    padding: 0 ${gutterWidth / 2}px;
  }
  @media (min-width: ${breakpoints[2]}) {
    display: grid;
    grid-template-columns: repeat(
      auto-fill,
      ${maxWidth[2] / 12 - gutterWidth}px
    );
    max-width: ${maxWidth[2]}px;
    @supports (grid-column-gap: ${gutterWidth}px) {
      grid-column-gap: ${gutterWidth}px;
    }
  }
  @media (min-width: ${breakpoints[3]}) {
    grid-template-columns: repeat(
      auto-fill,
      ${(maxWidth[3] - gutterWidth) / 12 - gutterWidth}px
    );
    max-width: ${maxWidth[3]}px;
    @supports (grid-column-gap: ${gutterWidth}px) {
      padding: 0 ${gutterWidth}px;
    }
  }
`;
export default Grid;
